import { useState } from 'react';
import { TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import useCachedManufacturerList from '@src/adapters/hooks/manufacturer/useCachedManufacturerList';
import IdNameDto from '@src/adapters/dto/shared/IdNameDto';

interface Props {
  update: (item: IdNameDto) => void;
}

function ManufacturerAutoComplete({ update }: Props) {
  const [options, setOptions] = useState<IdNameDto[]>([]);
  const [value, setValue] = useState<IdNameDto | null | string>(null);

  const { getList } = useCachedManufacturerList();
  const fetchOptions = async (query: string) => {
    try {
      const response = await getList(query);
      setOptions(response);
    } catch (error) {
      setOptions([]);
    }
  };

  const handleInputChange = (_: React.SyntheticEvent, value: string) => {
    if (value) {
      fetchOptions(value);
    } else {
      setOptions([]);
    }

    update({ id: '', name: value });
  };

  const handleChange = (_: React.SyntheticEvent, newValue: any | null) => {
    if (newValue && !newValue.id && newValue.name) {
      update({
        id: '',
        name: newValue.name,
      });
    } else if (newValue) {
      update(newValue);
    }

    setValue(newValue);
  };

  return (
    <Autocomplete
      freeSolo
      value={value}
      onChange={handleChange}
      onInputChange={handleInputChange}
      options={options}
      renderInput={(params: any) => (
        <TextField {...params} label="Select or Add Item" />
      )}
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          return option;
        }
        if (typeof option === 'object' && option.name) {
          return option.name;
        }
        return '';
      }}
      sx={{ width: '100%' }}
    />
  );
}

export default ManufacturerAutoComplete;
